import { render } from "./Marcyrl Pharma.vue?vue&type=template&id=0369e4b2&scoped=true"
const script = {}

import "./Marcyrl Pharma.vue?vue&type=style&index=0&id=0369e4b2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0369e4b2"

export default script